module.exports = __webpack_public_path__ + "static/media/white-car.75538b2d.png";